import type { FC } from "react";
import { ExternalLinkIcon } from "../../../shared/icons";
import type { InputProps } from "../../DynamicInput";
import { Text } from "./Text";

export const ExternalLink: FC<InputProps<string>> = props => {
  return <Text {...props} Icon={ExternalLinkIcon} />;
};
